// extracted by mini-css-extract-plugin
export var audioPlayer = "_tx-0";